import PreviewCertificate from "./PreviewCertificate";

export default PreviewCertificate;
